import(/* webpackMode: "eager", webpackExports: ["MainPage"] */ "/app/entities/main-page/main-page.tsx");
;
import(/* webpackMode: "eager" */ "/app/shared/utils/common.js");
;
import(/* webpackMode: "eager" */ "/app/shared/utils/hooks.tsx");
